import { render, staticRenderFns } from "./VerNotaMedica.vue?vue&type=template&id=57ccf305"
import script from "./VerNotaMedica.vue?vue&type=script&lang=js"
export * from "./VerNotaMedica.vue?vue&type=script&lang=js"
import style0 from "./VerNotaMedica.vue?vue&type=style&index=0&id=57ccf305&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports